module.exports = __webpack_public_path__ + "static/home1-2ff77fa891ccc2571d8017e770a7ccac.png";